/**
 * @name: 登录页面
 * @description:
 * @author: Wood
 * @date: 2019/3/26
 * @update: 2026-01-08 - 添加动画登录页面
 */
import React, {useEffect} from 'react';
import {withRouter} from "react-router-dom";
import AnimatedLogin from './animated_login.jsx';
import {getAccountInfo} from "../../lib/api_account.js";
import {useAccountStore} from "../../stores/useAccountStore";
import {useRoomsStore} from "../../stores/useRoomsStore";

const Login = () => {
    const {setAccount} = useAccountStore();
    const {setRooms} = useRoomsStore();

    useEffect(() => {
        // 获得登录用户信息
        getAccountInfo()
            .then(res => {
                if (res.code === 0) {
                    // 设置用户信息
                    setAccount(res.data);
                    setRooms(res.data.rooms);
                } else {
                }
            })
    }, []);

    return <AnimatedLogin />
}

export default withRouter(Login);